
import { defineComponent } from "vue";
import TermsOfUserView from "@/components/sections/TermsOfUserView.vue";
import ContainerView from "@/components/sections/ContainerView.vue";
import CardView from "@/components/controls/CardView.vue";

export default defineComponent({
    name: "AboutUsView",
    components: {
        TermsOfUserView,
        ContainerView,
        CardView
    },
    mounted() {
        this.$emit('scrolltop');
    },
})
